<template>
	<el-form
		v-if="dataForm.list && dataForm.list.length > 0"
		:model="form"
		ref="c_form"
		class="dyForm"
		:size="dataForm.config.size"
		:label-position="dataForm.config.labelPosition"
		:label-width="dataForm.config.labelWidth + 'px'"
	>
		<template v-if="dataForm.config.grid">
			<el-row :gutter="20">
				<template v-for="(item, index) of dataForm.list">
					<el-col v-if="item.type === 'text'" :span="24" :key="index">
						<form-item :item="item" :model="form" :optionList="optionList" v-on="$listeners" :key="index"></form-item>
					</el-col>
					<template v-else>
						<template v-if="item.type === 'group'">
							<form-group-item :item="item" :model="form" :optionList="optionList" :config="dataForm.config" v-on="$listeners" :key="index"></form-group-item>
						</template>
						<el-col :span="Number(item.options.grid)" v-else-if="item.options.grid" :key="index">
							<form-item :item="item" :model="form" :optionList="optionList" v-on="$listeners" :key="index"></form-item>
						</el-col>
						<el-col :span="Number(dataForm.config.grid)" v-else :key="index">
							<form-item :item="item" :model="form" :optionList="optionList" v-on="$listeners" :key="index"></form-item>
						</el-col>
					</template>
				</template>
			</el-row>
		</template>
		<template v-else>
			<form-item v-for="(item, index) of dataForm.list" :item="item" :model="form" :optionList="optionList" :key="index"></form-item>
		</template>
	</el-form>
</template>

<script>
import FormItem from '@/components/DForm/FormItem'
import FormGroupItem from '@/components/DForm/FormGroupItem'
export default {
	props: {
		dataForm: Object,
		optionList: Array,
	},
	data() {
		return {
			form: {},
		}
	},
	components: {
		FormItem,
		FormGroupItem,
	},
	created() {
		this.buildFormItem()
	},
	methods: {
		buildFormItem() {
			for (const item of this.dataForm.list) {
				this.$set(this.form, item.field, item.val || null)
			}
		},
		// 获取表单数据
		getFormVal(isRule) {
			return new Promise((resolve, reject) => {
				if (isRule == 'false') {
					resolve(this.form)
				} else {
					this.$refs['c_form'].validate(valid => {
						if (valid) {
							resolve(this.form)
						} else {
							reject({ code: -1 })
						}
					})
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped></style>
